import React from 'react';
import Header from '../../Header';
import Footer from '../../Footer';
import RootsHero from './RootsHero';
import RootsSection from './roots';
import WingsSection from './wings';
import MachineSection from './machine';
import WhyItWorksComponent from './Whyroots';
import RootsBottom from './rootsBottom';
import RootsFaq from './RootsFaq';

const RootsWings = () => {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <RootsHero />
          <RootsSection />
          <WingsSection />
          <MachineSection />
          <WhyItWorksComponent />
          <RootsBottom />
          <RootsFaq />
        </main>
        <Footer />
      </div>
    );
  };

  export default RootsWings;